var _defs, _rect, _rect2, _rect3, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__linear-gradient",
    x1: 49.16,
    y1: 48.84,
    x2: 105.69,
    y2: 115.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e542ff",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7543ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__linear-gradient-2",
    x1: 17.75,
    y1: 48,
    x2: 80,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6643f7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6643f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__linear-gradient-3",
    x1: 76.48,
    y1: 77.29,
    x2: 19.85,
    y2: 19.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c4aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64dfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__linear-gradient-4",
    x1: 49.16,
    y1: -89.86,
    x2: 105.69,
    y2: -23.04,
    xlinkHref: "#icon_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "icon_svg__cls-1",
    width: 96,
    height: 96,
    rx: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "icon_svg__cls-1",
    y: -138.71,
    width: 96,
    height: 96,
    rx: 9
  })), /*#__PURE__*/React.createElement("style", null, ".icon_svg__cls-1{fill:none}.icon_svg__cls-7{fill:#fff}"))), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 9,
    style: {
      fill: "#eff7ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#icon_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#icon_svg__linear-gradient)"
    },
    d: "m134.95 87.85-63.68 51.97-52.32-64 59.47-57.23 56.53 69.26z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 16,
    width: 62.25,
    height: 64,
    rx: 7,
    style: {
      fill: "url(#icon_svg__linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 17.75,
    width: 60.5,
    height: 60.5,
    rx: 6,
    style: {
      fill: "url(#icon_svg__linear-gradient-3)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon_svg__cls-7",
    x: 31,
    y: 32,
    width: 34,
    height: 6,
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "icon_svg__cls-7",
    x: 41,
    y: 45,
    width: 24,
    height: 6,
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "icon_svg__cls-7",
    x: 41,
    y: 58,
    width: 24,
    height: 6,
    rx: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon_svg__cls-7",
    cx: 34,
    cy: 48,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "icon_svg__cls-7",
    cx: 34,
    cy: 61,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#icon_svg__clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#icon_svg__linear-gradient-4)"
    },
    d: "M134.95-50.86 71.27 1.11 18.95-62.88l59.47-57.24 56.53 69.26z"
  })));
};

export { SvgIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";